import {capitalize} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import {connect} from 'react-redux';
import {daysToDeadline} from 'shared/college-earnings/utils';
import InfoTooltip from 'shared/components/info-tooltip';
import Stamp, {RED} from 'src/components/Stamp/Stamp';
import {UserType} from 'src/types/enums';

const propTypes = {
  deadlineDay: PropTypes.number,
  deadlineMonth: PropTypes.number,
  deadlineYear: PropTypes.number,
  deadlineTerm: PropTypes.string,
  deadlineTermYear: PropTypes.number,
  showSubmissionTerm: PropTypes.bool,
  showTooltipFlag: PropTypes.bool,
  userType: PropTypes.string,
};

export const EarningDeadlineSoonText = ({
  deadlineDay,
  deadlineMonth,
  deadlineYear,
  deadlineTerm,
  deadlineTermYear,
  showSubmissionTerm,
  showTooltipFlag = false,
  userType,
}) => {
  let earningText = '';

  // NB: For the portfolio sidebar, all earning statuses EXCEPT this one are shown as a tooltip.
  if (showTooltipFlag) {
    const d2d = daysToDeadline(deadlineYear, deadlineMonth, deadlineDay);
    let deadlineText = '';
    if (d2d === 0) {
      deadlineText = 'Today';
    } else if (d2d === 1) {
      deadlineText = '1 day'; // Not enough space to show "Tomorrow" :(
    } else {
      deadlineText = `${d2d} days`;
    }

    return (
      <div
        className="college-earnings-no-earnings-status-text-content"
        data-testid="earning-deadline-soon-text"
      >
        <Stamp color={RED} className="deadline">
          {deadlineText}
        </Stamp>
      </div>
    );
  }

  if (showSubmissionTerm) {
    const date = new Date(Date.UTC(deadlineYear, deadlineMonth - 1, deadlineDay));
    const options = {
      timeZone: 'UTC',
      month: 'numeric',
      day: 'numeric',
      year: '2-digit',
    };
    const deadline = new Intl.DateTimeFormat('en-US', options).format(date);
    const term = `${capitalize(deadlineTerm)} ${deadlineTermYear}`;

    earningText = `${term} Earnings deadline ${deadline}`;
  } else {
    earningText = `Earnings deadline ${deadlineMonth}/${deadlineDay}`;
  }

  return (
    <Stamp color={RED}>
      <div className="college-earnings-no-earnings-status-text-content">
        {earningText}
        {userType === UserType.CC_STUDENT && (
          <InfoTooltip iconSize={14} placement="top">
            Earn micro-scholarships for this school until its specified Earnings Deadline linked to
            your transfer term.
          </InfoTooltip>
        )}
      </div>
    </Stamp>
  );
};

EarningDeadlineSoonText.propTypes = propTypes;

export default connect((state) => ({
  userType: state.collegeProfile.userInfo.user,
}))(EarningDeadlineSoonText);
